import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '@/api'

export const useSettingsStore = defineStore('settings', () => {
  const settings = ref({})
  const menus = ref({}) // Dil bazlı menüler: { tr: [...], en: [...] }
  const isLoaded = ref(false)
  const isLoading = ref(false)

  const hasLoaded = computed(() => isLoaded.value)

  async function loadSettings() {
    // Eğer zaten yükleniyorsa veya yüklendiyse tekrar yükleme
    if (isLoading.value) return settings.value
    if (isLoaded.value) return settings.value

    isLoading.value = true
    try {
      const response = await api.get('/settings')
      settings.value = response.data || {}
      isLoaded.value = true
      return settings.value
    } catch (error) {
      console.error('Error loading settings:', error)
      isLoaded.value = true // Hata olsa bile yüklendi say
      return {}
    } finally {
      isLoading.value = false
    }
  }

  // Menüleri yükle (dil bazlı cache)
  async function loadMenus(lang = 'tr') {
    // Eğer bu dil için menü zaten yüklendiyse cache'den döndür
    if (menus.value[lang] && menus.value[lang].length > 0) {
      return menus.value[lang]
    }

    try {
      const response = await api.get(`/menus?location=header&lang=${lang}`)
      menus.value[lang] = response.data || []
      return menus.value[lang]
    } catch (error) {
      console.error('Error loading menus:', error)
      return getDefaultMenus(lang)
    }
  }

  // Menüleri al (cache'den)
  function getMenus(lang = 'tr') {
    return menus.value[lang] || []
  }

  // Default menüler
  function getDefaultMenus(lang = 'tr') {
    return [
      { id: 1, label: lang === 'tr' ? 'Ana Sayfa' : 'Home', url: `/${lang}`, children: [] },
      { id: 2, label: lang === 'tr' ? 'Hakkımızda' : 'About', url: `/${lang}/about`, children: [] },
      { id: 3, label: lang === 'tr' ? 'Hizmetlerimiz' : 'Services', url: `/${lang}/services`, children: [] },
      { id: 4, label: lang === 'tr' ? 'Projelerimiz' : 'Projects', url: `/${lang}/projects`, children: [] },
      { id: 5, label: lang === 'tr' ? 'Ekibimiz' : 'Team', url: `/${lang}/team`, children: [] },
      { id: 6, label: lang === 'tr' ? 'Blog' : 'Blog', url: `/${lang}/blog`, children: [] },
      { id: 7, label: lang === 'tr' ? 'İletişim' : 'Contact', url: `/${lang}/contact`, children: [] }
    ]
  }

  function getSettings() {
    return settings.value
  }

  // Belirli bir ayarı al
  function getSetting(key, defaultValue = '') {
    return settings.value[key] || defaultValue
  }

  return {
    settings,
    menus,
    isLoaded,
    isLoading,
    hasLoaded,
    loadSettings,
    loadMenus,
    getMenus,
    getDefaultMenus,
    getSettings,
    getSetting
  }
})
